import { Control, useController, FieldPath } from 'react-hook-form';
import { AceGenericFieldLayout } from './AceGenericFieldLayout';
import { ReactNode } from 'react';
import { Checkbox } from '@blueprintjs/core';
import { defaultFormatter } from './common';

interface AceCheckboxFieldProps<T extends object, V> {
  control: Control<T>;
  name: FieldPath<T>;
  formatter?: (value: V) => ReactNode;
  editable?: boolean;
  label?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  warning?: ReactNode;
  vertical?: boolean;
}

export function AceCheckboxField<T extends object, V>({
  control,
  name,
  editable,
  label,
  description,
  disabled,
  formatter = defaultFormatter,
  warning,
  vertical,
}: AceCheckboxFieldProps<T, V>) {
  const { field, fieldState } = useController({ control, name });

  const formattedValue = formatter(field.value);

  return (
    <AceGenericFieldLayout
      editable={editable}
      label={label}
      error={fieldState.error?.message}
      warning={warning}
      vertical={vertical}
      valueElement={formattedValue}
      inputElement={
        <Checkbox
          name={field.name}
          onChange={(e) => field.onChange(e.target.checked ? true : false)}
          onBlur={field.onBlur}
          checked={Boolean(field.value)}
          inputRef={field.ref}
          disabled={disabled}
        >
          {description}
        </Checkbox>
      }
    />
  );
}
